export function buildPathFormData ({
     nameEn,
     nameAr,
     descriptionEn,
     descriptionAr,
     price,
     discountPrice,
     discountStartAt,
     discountEndAt,
     image,
     categoryId,
     courses
}) {
     const formData = new FormData();
     formData.append('name_en',nameEn);
     formData.append('name_ar',nameAr);
     formData.append('description_en',descriptionEn);
     formData.append('description_ar',descriptionAr);
     formData.append('price',price);
     if (discountPrice !== '' && discountPrice != null) formData.append('discount_price', discountPrice);
     if (discountStartAt) formData.append('discount_start_at', discountStartAt);
     if (discountEndAt) formData.append('discount_end_at', discountEndAt);
     if (image instanceof File) formData.append('image', image);
     formData.append('category_id',categoryId);
     courses.forEach(course => {formData.append('course_ids[]', course);});

     return formData;
}